export default function LoadError({ message, onRetry }) {
  if (!message) return null;
  return <div role="alert" className="rounded-lg border border-red-200 bg-red-50 p-4 text-sm text-red-800"><p>{message}</p><button type="button" className="btn-secondary mt-2" onClick={onRetry}>Réessayer</button></div>;
}
